/**
 * @generated SignedSource<<a864204af828c1a6ca65072ea909b733>>
 * @relayHash 012b94d838ccafdd5de509e49f3c0f83
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2e5fb325edd76d29a10eea8db936fffa5dcfb8fc9aa71519d677de354419c83c

import type { ConcreteRequest, Query } from 'relay-runtime';
export type ConfluencePricingEndOfTrialPremiumToStandardQuery$variables = {
  cloudId: string;
  productKey: string;
};
export type ConfluencePricingEndOfTrialPremiumToStandardQuery$data = {
  readonly tenantContexts: ReadonlyArray<{
    readonly entitlementInfo: {
      readonly entitlement: {
        readonly experienceCapabilities?: {
          readonly changeOfferingV2: {
            readonly experienceUrl: string | null | undefined;
            readonly isAvailableToUser: boolean | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly premiumPrice?: ReadonlyArray<{
          readonly listPriceForOrderWithDefaults: ReadonlyArray<{
            readonly averageAmountPerUnit: number | null | undefined;
            readonly item: {
              readonly chargeElement: string | null | undefined;
            } | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined> | null | undefined;
        readonly standardPrice?: ReadonlyArray<{
          readonly listPriceForOrderWithDefaults: ReadonlyArray<{
            readonly averageAmountPerUnit: number | null | undefined;
            readonly item: {
              readonly chargeElement: string | null | undefined;
            } | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined> | null | undefined;
        readonly subscription?: {
          readonly trial: {
            readonly timeLeft: number | null | undefined;
          } | null | undefined;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined> | null | undefined;
};
export type ConfluencePricingEndOfTrialPremiumToStandardQuery = {
  response: ConfluencePricingEndOfTrialPremiumToStandardQuery$data;
  variables: ConfluencePricingEndOfTrialPremiumToStandardQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "productKey"
  }
],
v1 = [
  {
    "items": [
      {
        "kind": "Variable",
        "name": "cloudIds.0",
        "variableName": "cloudId"
      }
    ],
    "kind": "ListValue",
    "name": "cloudIds"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "hamsProductKey",
    "variableName": "productKey"
  }
],
v3 = {
  "concreteType": "CcpEntitlementExperienceCapabilities",
  "kind": "LinkedField",
  "name": "experienceCapabilities",
  "plural": false,
  "selections": [
    {
      "args": [
        {
          "kind": "Literal",
          "name": "offeringName",
          "value": "standard"
        }
      ],
      "concreteType": "CcpChangeOfferingExperienceCapability",
      "kind": "LinkedField",
      "name": "changeOfferingV2",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isAvailableToUser"
        },
        {
          "kind": "ScalarField",
          "name": "experienceUrl"
        }
      ],
      "storageKey": "changeOfferingV2(offeringName:\"standard\")"
    }
  ]
},
v4 = {
  "concreteType": "CcpTrial",
  "kind": "LinkedField",
  "name": "trial",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "timeLeft"
    }
  ]
},
v5 = [
  {
    "kind": "Literal",
    "name": "offeringName",
    "value": "Standard"
  }
],
v6 = {
  "concreteType": "CcpListPriceEstimate",
  "kind": "LinkedField",
  "name": "listPriceForOrderWithDefaults",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "averageAmountPerUnit"
    },
    {
      "concreteType": "CcpPricingPlanItem",
      "kind": "LinkedField",
      "name": "item",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "chargeElement"
        }
      ]
    }
  ]
},
v7 = [
  (v6/*: any*/)
],
v8 = [
  {
    "kind": "Literal",
    "name": "offeringName",
    "value": "Premium"
  }
],
v9 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v10 = {
  "kind": "ScalarField",
  "name": "id"
},
v11 = [
  (v6/*: any*/),
  (v10/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ConfluencePricingEndOfTrialPremiumToStandardQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
          {
            "args": (v2/*: any*/),
            "kind": "LinkedField",
            "name": "entitlementInfo",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "entitlement",
                "plural": false,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v3/*: any*/),
                      {
                        "concreteType": "CcpSubscription",
                        "kind": "LinkedField",
                        "name": "subscription",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/)
                        ]
                      },
                      {
                        "alias": "standardPrice",
                        "args": (v5/*: any*/),
                        "concreteType": "CcpEntitlementOfferingTransition",
                        "kind": "LinkedField",
                        "name": "defaultOfferingTransitions",
                        "plural": true,
                        "selections": (v7/*: any*/),
                        "storageKey": "defaultOfferingTransitions(offeringName:\"Standard\")"
                      },
                      {
                        "alias": "premiumPrice",
                        "args": (v8/*: any*/),
                        "concreteType": "CcpEntitlementOfferingTransition",
                        "kind": "LinkedField",
                        "name": "defaultOfferingTransitions",
                        "plural": true,
                        "selections": (v7/*: any*/),
                        "storageKey": "defaultOfferingTransitions(offeringName:\"Premium\")"
                      }
                    ],
                    "type": "CcpEntitlement"
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ConfluencePricingEndOfTrialPremiumToStandardQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
          {
            "args": (v2/*: any*/),
            "kind": "LinkedField",
            "name": "entitlementInfo",
            "plural": false,
            "selections": [
              (v9/*: any*/),
              {
                "kind": "LinkedField",
                "name": "entitlement",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v3/*: any*/),
                      {
                        "concreteType": "CcpSubscription",
                        "kind": "LinkedField",
                        "name": "subscription",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v10/*: any*/)
                        ]
                      },
                      {
                        "alias": "standardPrice",
                        "args": (v5/*: any*/),
                        "concreteType": "CcpEntitlementOfferingTransition",
                        "kind": "LinkedField",
                        "name": "defaultOfferingTransitions",
                        "plural": true,
                        "selections": (v11/*: any*/),
                        "storageKey": "defaultOfferingTransitions(offeringName:\"Standard\")"
                      },
                      {
                        "alias": "premiumPrice",
                        "args": (v8/*: any*/),
                        "concreteType": "CcpEntitlementOfferingTransition",
                        "kind": "LinkedField",
                        "name": "defaultOfferingTransitions",
                        "plural": true,
                        "selections": (v11/*: any*/),
                        "storageKey": "defaultOfferingTransitions(offeringName:\"Premium\")"
                      }
                    ],
                    "type": "CcpEntitlement"
                  },
                  (v10/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "012b94d838ccafdd5de509e49f3c0f83",
    "id": "2e5fb325edd76d29a10eea8db936fffa5dcfb8fc9aa71519d677de354419c83c",
    "metadata": {},
    "name": "ConfluencePricingEndOfTrialPremiumToStandardQuery",
    "operationKind": "query",
    "text": "query ConfluencePricingEndOfTrialPremiumToStandardQuery($cloudId:ID!,$productKey:String!){tenantContexts(cloudIds:[$cloudId]){entitlementInfo(hamsProductKey:$productKey){__typename,entitlement{__typename,...on CcpEntitlement{experienceCapabilities{changeOfferingV2(offeringName:\"standard\"){isAvailableToUser,experienceUrl}},subscription{trial{timeLeft},id},standardPrice:defaultOfferingTransitions(offeringName:\"Standard\"){listPriceForOrderWithDefaults{averageAmountPerUnit,item{chargeElement}},id},premiumPrice:defaultOfferingTransitions(offeringName:\"Premium\"){listPriceForOrderWithDefaults{averageAmountPerUnit,item{chargeElement}},id}},id}}}}"
  }
};
})();

(node as any).hash = "1a80aa9a135b73fab3917910cfa2d966";

export default node;
